<template>
  <div class="cont" v-if="loading" style="overflow: hidden">
    <div v-if="loading" class="progress-bar">
      <div class="progress-bar-value"></div>
    </div>
    <div v-if="loading" class="loading-overlay"></div>
  </div>
</template>

<script>
export default {
  props: {
    loading: Boolean,
  },
};
</script>

<style lang="scss">
.cont {
  max-width: 100%;
  max-height: 100%;
}
@keyframes indeterminateAnimation {
  0% {
    transform: translateX(0) scaleX(0);
  }
  40% {
    transform: translateX(0) scaleX(0.4);
  }
  100% {
    transform: translateX(100%) scaleX(0.5);
  }
}
.progress-bar {
  height: 4px;
  background-color: rgba(5, 114, 206, 0.2);
  width: 100%;
  overflow: hidden;
  position: absolute;
  top: -10px;
  border-radius: 15px;
}

.progress-bar-value {
  width: 100%;
  height: 100%;
  background-color: var(--info);
  animation: indeterminateAnimation 1s infinite linear;
  transform-origin: 0% 50%;
}
</style>
